export default {
  data() {
    return {
      // eslint-disable-next-line
      closeReflectionOptions: [
        "All OK",
        "Lessons",
        "Plan",
        "Permit",
        "Budget",
        "Team"
      ],
      // eslint-disable-next-line
      reachBusinessOperationsOptions: [
        "Company",
        "Facility",
        "Equipment",
        "Asset",
        "Material",
        "Process"
      ],
      // eslint-disable-next-line
      businessDriverOptions: [
        "Business",
        "Compliance",
        "Reliability",
        "Protect",
        "Cost",
        "Improve"
      ],
      // eslint-disable-next-line
      businessProcessCriticailityOptions: [
        "Business",
        "Production",
        "Safety",
        "Process Safety",
        "Emergency",
        "Other"
      ],
      // eslint-disable-next-line
      businessProcessCategoryOptions: [
        "Isolation",
        "Deisolation",
        "Startup",
        "Shutdown",
        "Maintenance",
        "Test",
        "Health",
        "Safety",
        "Inspection",
        "Construction",
        "Commissioning",
        "Decommissioning",
        "Other"
      ],
      // eslint-disable-next-line
      businessProcessComplexityOptions: ["Low", "Medium", "High"],
      // eslint-disable-next-line
      businessRiskOptions: ["Low", "Medium", "High"],
      // eslint-disable-next-line
      budgetTypeOptions: [
        "Opex",
        "Capex",
        "Project"
      ],
      // eslint-disable-next-line
      projectEvalatualtionMethod: [
        "Peer",
        "ROI",
        "CBA",
        "NPV",
        "DCF",
        "BP"
      ],
      // eslint-disable-next-line
      businessAreaImpactOptions: [
        "Transport",
        "Project",
        "Ops"
      ],
      // eslint-disable-next-line
      businessOwnershipOptions: [
        "Private",
        "Public",
        "Government"
      ],
      // eslint-disable-next-line
      businessOutputOptions: [
        "Storage",
        "Solids",
        "Liquids",
        "Gas",
        "Products",
        "Services"
      ],
      // eslint-disable-next-line
      businessRegulationOptions: [
        "Basic",
        "Process",
        "Licence"
      ],
      // eslint-disable-next-line
      engineeringRequestTypeOptions: [
        "Study",
        "Qualify",
        "Deviation",
        "Modification",
        "Project"
      ],
      // eslint-disable-next-line
      planTypeOptions: [
        "Execution",
        "Campaign",
        "Shutdown",
        "Project"
      ],
      // eslint-disable-next-line
      businessThemeOptions: [
        "General",
        "Engineering",
        "Operations",
        "Project",
        "Maintenance",
        "Contract",
        "Vendor"
      ],
      closeQualityTypeOptions: ["C0", "C1", "C2", "C3", "C4"],
      recommendationTypeOptions: ["R0", "R1", "R2", "R3", "R4"],
      // eslint-disable-next-line
      executionPlanProgressOptions: [
        "NA",
        "Required",
        "Requested",
        "Resourced",
        "Progress",
        "Ready"
      ]
    };
  }
};
